exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.dy-input-checkbox-container {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.dy-input-checkbox-container > .el-input {\n    width: 180px;\n}\n.dy-input-checkbox-container > .el-input.input-two {\n      width: 180px;\n      margin-left: 10px;\n}\n.dy-input-checkbox-container > .check-group {\n    margin-left: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54f8e524","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dynamic/support/components/InputCheckbox.vue
// module id = FBD/
// module chunks = 289